module.exports = __webpack_public_path__ + "static/media/fullLogo.b2b3aeed.svg";